import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

const stepsData = [
  { title: 'freeTv.steps.step1.title', subtitle: 'freeTv.steps.step1.subtitle' },
  { title: 'freeTv.steps.step2.title', subtitle: 'freeTv.steps.step2.subtitle' },
  { title: 'freeTv.steps.step3.title', subtitle: 'freeTv.steps.step3.subtitle' },
];

const Steps = () => {
  const [t] = useTranslation();

  return (
    <div className="steps section section--grey">
      <div className="page-content">
        <Typography className="section__title" align="center" component="h2" variant="h3">
          <Trans
            i18nKey="freeTv.steps.title"
            components={{
              span: <span className="text-color--primary" />,
            }}
          />
        </Typography>
        <Typography className="steps__subtitle body3 m-b-25" align="center">
          {t('freeTv.steps.subtitle')}
        </Typography>
        <ul className="steps__list list">
          {stepsData.map((item, idx) => (
            <li key={idx}>
              <span className="list__icon">{idx + 1}</span>
              <Typography className="list__title m-b-20" align="center" component="h4" variant="h6">
                {t(item.title)}
              </Typography>
              <Typography className="body3" align="center">
                <Trans
                  i18nKey={t(item.subtitle)}
                  components={{
                    span: <span className="text-medium" />,
                  }}
                />
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(Steps);
